module.exports = __webpack_public_path__ + "img/chuyi.bff955d9.png";